// add aria-hidden="true" on all br tags

document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('br').forEach(function (br) {
    br.setAttribute('aria-hidden', 'true');
  });
});

//th broken aria-label issue fix "aria-labelled by removed

window.addEventListener('load', function () {
  document.querySelectorAll('[aria-labelledby]').forEach(function (el) {
    const refId = el.getAttribute('aria-labelledby');

    if (!document.getElementById(refId)) {
      el.removeAttribute('aria-labelledby');
    }
  });
});

// header megamenu 
document.addEventListener('DOMContentLoaded', function () {
  fixClickAccessibleMegaMenus();
  fixMegaMenuFakeHeadingLinks();
});
document.addEventListener('shopify:section:load', function () {
  fixClickAccessibleMegaMenus();
  fixMegaMenuFakeHeadingLinks();
});
function fixClickAccessibleMegaMenus() {
  var header = document.getElementById('SiteHeader');
  if (!header) return;
  createMegaMenuLiveRegion(header);
  var detailsList = header.querySelectorAll('.site-nav details, .header-item--navigation details, .text-center details');
  detailsList.forEach(function (details, index) {
    if (details.hasAttribute('data-click-accessible-menu-fixed')) return;
    var summary = getDirectSummaryElement(details);
    if (!summary) return;
    var panel = getDirectPanelElement(details, summary);
    if (!panel) return;
    var label = summary.textContent.trim().replace(/\s+/g, ' ');
    if (!label) return;
    details.setAttribute('data-click-accessible-menu-fixed', 'true');
    if (!panel.id) {
      panel.id = 'accessible-mega-panel-' + index;
    }
    summary.classList.add('accessible-original-summary');
    summary.setAttribute('aria-hidden', 'true');
    summary.setAttribute('tabindex', '-1');

    var button = document.createElement('button');

    button.type = 'button';
    button.innerHTML = summary.innerHTML;
    button.className = summary.className.replace('accessible-original-summary', '').trim();
    button.classList.add('accessible-mega-trigger');
    button.setAttribute('aria-label', label);
    button.setAttribute('aria-expanded', 'false');
    button.setAttribute('aria-controls', panel.id);

    if (!button.classList.contains('site-nav__link')) {
      button.classList.add('site-nav__link');
    }

    if (!button.querySelector('.accessible-dropdown-icon')) {
      var icon = document.createElement('span');
      icon.className = 'accessible-dropdown-icon';
      icon.setAttribute('aria-hidden', 'true');
      button.appendChild(icon);
    }

    details.parentNode.insertBefore(button, details);

    if (details.hasAttribute('open')) {
      details.removeAttribute('open');
    }

    button.addEventListener('focusin', function () {
      closeAllClickAccessibleMegaMenus(header, button, false);
    });

    button.addEventListener('click', function (event) {
      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();

      var isOpen = details.hasAttribute('open');

      closeAllClickAccessibleMegaMenus(header, button, false);

      if (isOpen) {
        closeClickAccessibleMegaMenu(details, button, {
          keepFocus: true,
          announce: true,
          label: label
        });
      } else {
        openClickAccessibleMegaMenu(details, button, {
          keepFocus: true,
          announce: true,
          label: label
        });
      }
    });

    button.addEventListener('keydown', function (event) {
      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();

        button.click();
      }

      if (event.key === 'Escape') {
        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();

        closeClickAccessibleMegaMenu(details, button, {
          keepFocus: true,
          announce: true,
          label: label
        });
      }

      if (event.key === 'ArrowDown') {
        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();

        closeAllClickAccessibleMegaMenus(header, button, false);

        openClickAccessibleMegaMenu(details, button, {
          keepFocus: false,
          announce: true,
          label: label
        });

        var firstFocusable = details.querySelector(
          // 'a, button:not(.accessible-mega-trigger), input, select, textarea, [tabindex]:not([tabindex="-1"])'
          'a, button:not(.accessible-mega-trigger), input, select, textarea'
        );

        if (firstFocusable) {
          firstFocusable.focus();
        }
      }
    }, true);

    details.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') {
        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();

        closeClickAccessibleMegaMenu(details, button, {
          keepFocus: true,
          announce: true,
          label: label
        });
      }
    }, true);
  });

  if (!header.hasAttribute('data-click-accessible-global-events')) {
    header.setAttribute('data-click-accessible-global-events', 'true');

    document.addEventListener('click', function (event) {
      if (!event.target.closest('#SiteHeader')) {
        closeAllClickAccessibleMegaMenus(header, null, false);
      }
    });

    document.addEventListener('focusin', function (event) {
      handleMegaMenuFocusChange(header, event.target);
    }, true);

    document.addEventListener('keydown', function (event) {
      if (event.key !== 'Escape') return;
      var activeDetails = header.querySelector('details[open][data-click-accessible-menu-fixed]');
      if (!activeDetails) return;
      var activeButton = findButtonForDetails(activeDetails);
      if (!activeButton) return;
      var label = activeButton.getAttribute('aria-label') || activeButton.textContent.trim().replace(/\s+/g, ' ');
      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();
      closeClickAccessibleMegaMenu(activeDetails, activeButton, {
        keepFocus: true,
        announce: true,
        label: label
      });
    }, true);
  }
}
function fixMegaMenuFakeHeadingLinks() {
  var header = document.getElementById('SiteHeader');
  if (!header) return;
  var fakeHeadingLinks = header.querySelectorAll(
    'details a[href="#"], details a[href=""], details a:not([href])'
  );
  fakeHeadingLinks.forEach(function (link) {
    if (link.hasAttribute('data-heading-link-fixed')) return;
    var text = link.textContent.trim().replace(/\s+/g, ' ');
    if (!text) return;
    var span = document.createElement('span');
    span.innerHTML = link.innerHTML;
    span.className = link.className;
    span.classList.add('accessible-mega-heading');
    span.setAttribute('role', 'heading');
    span.setAttribute('aria-level', '2');
    link.setAttribute('data-heading-link-fixed', 'true');
    link.parentNode.replaceChild(span, link);
  });
}
function handleMegaMenuFocusChange(header, target) {
  if (!header.contains(target)) {
    closeAllClickAccessibleMegaMenus(header, null, false);
    return;
  }
  var openButtons = header.querySelectorAll('.accessible-mega-trigger[aria-expanded="true"][aria-controls]');
  openButtons.forEach(function (button) {
    var panelId = button.getAttribute('aria-controls');
    var panel = document.getElementById(panelId);
    if (!panel) return;
    var details = panel.closest('details');
    if (!details) return;
    var focusIsOnCurrentButton = target === button;
    var focusIsInsideCurrentMenu = details.contains(target);
    if (!focusIsOnCurrentButton && !focusIsInsideCurrentMenu) {
      closeClickAccessibleMegaMenu(details, button, {
        keepFocus: false,
        announce: false,
        label: ''
      });
    }
  });
}
function getDirectSummaryElement(details) {
  var children = Array.prototype.slice.call(details.children);
  for (var i = 0; i < children.length; i++) {
    if (children[i].tagName && children[i].tagName.toLowerCase() === 'summary') {
      return children[i];
    }
  }
  return null;
}
function getDirectPanelElement(details, summary) {
  var children = Array.prototype.slice.call(details.children);
  for (var i = 0; i < children.length; i++) {
    if (children[i] !== summary) {
      return children[i];
    }
  }
  return null;
}
function findButtonForDetails(details) {
  var previous = details.previousElementSibling;
  if (previous && previous.classList.contains('accessible-mega-trigger')) {
    return previous;
  }
  var summary = getDirectSummaryElement(details);
  var panel = getDirectPanelElement(details, summary);
  if (!panel || !panel.id) return null;
  return document.querySelector('.accessible-mega-trigger[aria-controls="' + panel.id + '"]');
}
function openClickAccessibleMegaMenu(details, button, options) {
  var label = options && options.label ? options.label : '';
  var keepFocus = options && options.keepFocus;
  var announce = options && options.announce;
  details.setAttribute('open', '');
  button.setAttribute('aria-expanded', 'true');
  var parentItem = details.closest('li');
  if (parentItem) {
    parentItem.classList.add('is-open');
  }
  if (announce && label) {
    updateMegaMenuLiveRegion(label + ' expanded');
  }
  if (keepFocus) {
    focusButton(button);
  }
}
function closeClickAccessibleMegaMenu(details, button, options) {
  var label = options && options.label ? options.label : '';
  var keepFocus = options && options.keepFocus;
  var announce = options && options.announce;
  details.removeAttribute('open');
  button.setAttribute('aria-expanded', 'false');
  var parentItem = details.closest('li');
  if (parentItem) {
    parentItem.classList.remove('is-open');
  }
  if (announce && label) {
    updateMegaMenuLiveRegion(label + ' collapsed');
  }
  if (keepFocus) {
    focusButton(button);
  }
}
function closeAllClickAccessibleMegaMenus(header, exceptButton, announce) {
  var buttons = header.querySelectorAll('.accessible-mega-trigger[aria-controls]');
  buttons.forEach(function (button) {
    if (exceptButton && button === exceptButton) return;
    var panelId = button.getAttribute('aria-controls');
    var panel = document.getElementById(panelId);
    if (!panel) return;
    var details = panel.closest('details');
    if (!details) return;
    var label = button.getAttribute('aria-label') || button.textContent.trim().replace(/\s+/g, ' ');
    closeClickAccessibleMegaMenu(details, button, {
      keepFocus: false,
      announce: !!announce,
      label: label
    });
  });
}
function focusButton(button) {
  window.setTimeout(function () {
    if (document.activeElement !== button) {
      button.focus({ preventScroll: true });
    }
  }, 30);
}
function createMegaMenuLiveRegion(header) {
  if (header.querySelector('.accessible-vo-status')) return;
  var liveRegion = document.createElement('div');
  liveRegion.className = 'accessible-vo-status';
  liveRegion.setAttribute('aria-live', 'polite');
  liveRegion.setAttribute('aria-atomic', 'true');
  header.appendChild(liveRegion);
}
function updateMegaMenuLiveRegion(message) {
  var liveRegion = document.querySelector('#SiteHeader .accessible-vo-status');
  if (!liveRegion) return;
  liveRegion.textContent = '';
  window.setTimeout(function () {
    liveRegion.textContent = message;
  }, 50);
}

///back to top
document.addEventListener('DOMContentLoaded', function () {
  var backToTopButton = document.getElementById('back-to-top');
  window.onscroll = function () {
    if (window.pageYOffset > 300) {
      backToTopButton.style.display = 'block';
    } else {
      backToTopButton.style.display = 'none';
    }
  };
  backToTopButton.onclick = function (e) {
    e.preventDefault();
    window.scrollTo({ top: 0, behavior: 'smooth' });
    window.setTimeout(function () {
      document.getElementById('backtoheader').focus();
    }, 600);
  };
});

document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('h2').forEach(function (h2) {
        if (h2.querySelector('meta[charset]')) {
            h2.remove();
        }
    });
});

// empty h1 removal
$("h1").each(function () {
  if ($(this).html().toLowerCase().includes('<meta charset="utf-8">')) {
    $(this).remove();
  }
});

document.addEventListener("DOMContentLoaded", () => {

  function removeEmptyH1() {
    document.querySelectorAll("h1").forEach((h1) => {
      if (!h1.textContent.trim() && h1.children.length === 0) {
        h1.remove();
      }
    });
  }

  removeEmptyH1();

  new MutationObserver(removeEmptyH1).observe(document.body, {
    childList: true,
    subtree: true
  });

});

// Social and External link warning Fixed
document.addEventListener("DOMContentLoaded", function () {
    addExternalLinkWarning();
});


document.addEventListener("shopify:section:load", function () {
    addExternalLinkWarning();
});


document.addEventListener("shopify:section:reorder", function () {
    addExternalLinkWarning();
});


function addExternalLinkWarning() {

    const currentDomain = window.location.hostname;

    document.querySelectorAll('a[target="_blank"][href]').forEach(function (link) {

        const href = link.getAttribute("href");

        if (
            !href ||
            href.startsWith("#") ||
            href.startsWith("mailto:") ||
            href.startsWith("tel:")
        ) {
            return;
        }


        let linkURL;

        try {
            linkURL = new URL(href, window.location.origin);
        } catch (error) {
            return;
        }


        // Check external links only
        if (linkURL.hostname !== currentDomain) {


            // Prevent duplicate warning
            if (
                link.classList.contains("external-warning-added") ||
                link.querySelector(".external-link-warning") ||
                link.getAttribute("aria-label")?.includes("third-party website")
            ) {
                return;
            }


            const warningText = document.createElement("span");

            warningText.className = "external-link-warning visually-hidden";

            warningText.textContent =
                " Redirecting to a third-party website. Opens in a new tab.";


            link.appendChild(warningText);


            // Update accessible name once
            const existingLabel = link.getAttribute("aria-label");

            if (existingLabel) {

                link.setAttribute(
                    "aria-label",
                    existingLabel + ". Redirecting to a third-party website. Opens in a new tab."
                );

            } else {

                link.setAttribute(
                    "aria-label",
                    link.textContent.trim() +
                    ". Redirecting to a third-party website. Opens in a new tab."
                );

            }


            link.classList.add("external-warning-added");

        }

    });

}